import React from "react";
import { Input, Label, makeStyles } from "@fluentui/react-components";
import { themeTokens } from "../../../../utils/Theming";

const useStyles = makeStyles({
  container: {
    display: "flex",
    alignItems: "center",
    marginBottom: themeTokens.spacingVerticalMNudge,
  },
  label: {
    width: "10%",
  },
  input: {
    width: "90%",
    "& input": {
      cursor: "default",
      backgroundColor: "transparent",
    },
    "&::after": {
      display: "none",
    }
  },
});

const InputReadOnlyField = ({ value, icon }: { value: string; icon?: React.ReactNode }) => {
  const styles = useStyles();

  const processValue = (val: string | null) => {
    if (!val) return "";

    return val
      .split(",")
      .map((v) => v.trim())
      .filter((v) => v !== "null" && v !== "")
      .join(", ");
  };

  const displayValue = processValue(value);

  return (
    <div className={styles.container}>
      {icon && <Label className={styles.label}>{icon}</Label>}
      <Input className={styles.input} value={displayValue} readOnly />
    </div>
  );
};

export default InputReadOnlyField;
